import React, { useCallback, useEffect, useState } from "react"
import { CustomerDetail as cd, Customernterface, userUpdate } from "../../services/authinterface"
import { useFormik } from "formik"

import { request } from "../../services/request"
import * as Yup from "yup"
import { Form } from "react-bootstrap"

import { toast, ToastContainer } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"
import demo_image from "../../assets/images/demo_user.png"
// import moment from "moment"
import PrimaryButton from "../../components/subComponents/PrimaryButton"
// import SecondaryButton from "../../components/subComponents/SecondaryButton"
import { useDispatch } from "react-redux"
import { changeloaderState } from "../../store/loaderSlice"
import { AppDispatch } from "../../store/store"
import { FaChevronLeft } from "react-icons/fa"

const Icon: any = FaChevronLeft

const CustomerEdit: React.FC = () => {
  const navigate = useNavigate()
  const param = useParams()
  const dispatch = useDispatch<AppDispatch>()

  const [customers, setCustomers] = useState<cd[]>([])
  const [profileImage, setProfileImage] = useState<File | null>(null)

  const fetchCustomerDetails = useCallback(async () => {
    try {
      dispatch(changeloaderState(true))

      const response = await request<Customernterface>({
        url: `/adminCustomers/viewCustomer/${param.id}`,
        method: "GET",
      })
      if (response.data) {
        setCustomers(response.data)
      } else {
        toast.error("Failed to fetch customers: " + response.message)
      }
    } catch (error) {
    } finally {
      dispatch(changeloaderState(false))
    }
  }, [param.id, dispatch])

  useEffect(() => {
    fetchCustomerDetails()
  }, [fetchCustomerDetails])

  const validationSchema = Yup.object().shape({
    first_name: Yup.string().required("Please enter first name"),
    last_name: Yup.string().required("Please enter last name"),

    email: Yup.string().required("Please enter Email").email("Please enter valid Email"),
  })

  const formik = useFormik({
    initialValues: {
      email: customers[0]?.email || "",
      first_name: customers[0]?.first_name || "",
      last_name: customers[0]?.last_name || "",
      notes: customers[0]?.notes || "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const formData = new FormData()
        formData.append("first_name", values.first_name)
        formData.append("last_name", values.last_name)
        formData.append("notes", values.notes)
        if (profileImage) {
          formData.append("image", profileImage)
        }
        const response = await request<userUpdate>({
          url: `/adminCustomers/updateCustomer/${param.id}`,
          method: "POST",
          data: formData,
        })
        if (response.data) {
          toast.success(response.message)
          setTimeout(() => {
            navigate(`/customer/view/${param.id}`)
          }, 1000)
        } else {
          toast.error(response.message)
        }
      } catch (error: any) {
        toast.error(`${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`)
      }
    },
  })

  // const UploadImageIcon = (
  //   <svg
  //     xmlns='http://www.w3.org/2000/svg'
  //     fill='none'
  //     viewBox='0 0 24 24'
  //     strokeWidth={1.5}
  //     stroke='currentColor'
  //     className='size-6'
  //   >
  //     <path
  //       strokeLinecap='round'
  //       strokeLinejoin='round'
  //       d='M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5'
  //     />
  //   </svg>
  // )

  React.useEffect(() => {
    if (formik.isSubmitting && Object.keys(formik.errors).length > 0) {
      // Get the first error key
      const firstErrorKey = Object.keys(formik.errors)[0]
      // Select the input element by name
      const errorElement = document.querySelector(`input[name="${firstErrorKey}"]`) as HTMLElement
      if (errorElement) {
        errorElement.focus()
      }
    }
  }, [formik.isSubmitting, formik.errors])

  const getBack = () => {
    navigate(-1)
  }

  return (
    <section className='dashboard-section'>
      <ToastContainer position='top-right' autoClose={2000} theme='light' />

      <div className='container'>
        <div className='row justify-content-center'>
          <div className='col-12'>
            <div className='d-flex gap-1 customer-detail-line'>
              <button onClick={getBack} className='d-flex align-items-center'>
                <Icon size={20} />
              </button>
              <div className='dashboard-table-title-section'>
                <h2>Edit Customer Details</h2>
              </div>
            </div>
          </div>
          <div className='col-xl-8 col-lg-10 col-md-10 col-12 mt-4'>
            <div>
              <form onSubmit={formik.handleSubmit} className='customer-edit-form'>
                <div className='inputName-section'>
                  <div className='form-group'>
                    <label htmlFor='customerName'>First Name</label>
                    <Form.Control
                      type='text'
                      className='form-control'
                      id='customerName'
                      name='first_name'
                      placeholder='Enter first name'
                      value={formik.values.first_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={!!formik.errors.first_name && formik.touched.first_name}
                    />

                    <span className='text-red-500 text-xs'>
                      {formik.touched.first_name && formik.errors.first_name}
                    </span>
                  </div>

                  <div className='form-group'>
                    <label htmlFor='customerName'>Last Name</label>
                    <Form.Control
                      type='text'
                      className='form-control'
                      id='customerName'
                      name='last_name'
                      placeholder='Enter last name'
                      value={formik.values.last_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={!!formik.errors.last_name && formik.touched.last_name}
                    />
                    <span className='text-red-500 text-xs'>
                      {formik.touched.last_name && formik.errors.last_name}
                    </span>
                  </div>
                </div>

                <div className='form-group'>
                  <label htmlFor='customerEmail'>Customer Email</label>
                  <Form.Control
                    type='email'
                    className='form-control'
                    id='customerEmail'
                    name='email'
                    placeholder='Enter email'
                    value={formik.values.email}
                    disabled
                    isInvalid={!!formik.errors.email && formik.touched.email}
                  />
                  <span className='text-red-500 text-xs'>
                    {formik.touched.email && formik.errors.email}
                  </span>
                </div>

                <div className='form-group'>
                  <label htmlFor='customerNotes'>Internal Notes</label>
                  <textarea
                    className='form-control'
                    id='customerNotes'
                    name='notes'
                    placeholder='Enter Notes'
                    value={formik.values.notes}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    // disabled={!!formik.errors.notes && formik.touched.notes}
                  />
                  <span className='text-red-500 text-xs'>
                    {formik.touched.notes && formik.errors.notes}
                  </span>
                </div>

                <div className='profile-img-section'>
                  <div className='profile-img-wrp'>
                    <img
                      className='customer-profile-image'
                      src={
                        profileImage
                          ? URL.createObjectURL(profileImage)
                          : customers[0]?.acount_profile_image == null
                            ? demo_image
                            : customers[0]?.acount_profile_image
                      }
                      alt='Customer'
                    />
                  </div>
                  <div className='form-group'>
                    <label htmlFor='image' className='uploadeimg-section'>
                      <div className='icon'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          fill='none'
                          viewBox='0 0 24 24'
                          strokeWidth={1.5}
                          stroke='currentColor'
                          className='size-6'
                        >
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            d='M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5'
                          />
                        </svg>
                      </div>
                      <div className='text-section'>
                        <h3>Upload Image</h3>
                        <p>Upload PNG, JPG, or JPEG files only (Max size: 1MB).</p>
                      </div>
                    </label>
                    <input
                      type='file'
                      className='form-control'
                      hidden
                      id='image'
                      accept='image/*'
                      onChange={(e) => {
                        if (e.currentTarget.files && e.currentTarget.files[0]) {
                          setProfileImage(e.currentTarget.files[0])
                        }
                      }}
                    />
                  </div>
                </div>
                <PrimaryButton type='submit' label='Submit' className='editFormButton' />
                {/* <button type='submit' className=''>
                  {" "}
                  Submit
                </button> */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CustomerEdit
